import { isIOS } from 'react-device-detect';
import Logo from '@assets/images/logo/logo-white-no-bg.svg';
import LogoBorder from '@assets/images/logo/logo-border.svg';
import Download from '@assets/images/add-to-home.svg';

interface AddToHomeScreenProps {
	onInstall?: () => void;
	onProceed?: () => void;
}

export default function AddToHomeScreen({ onInstall, onProceed }: AddToHomeScreenProps) {
	const handleProceedToSignIn = () => {
		if (onProceed) {
			onProceed();
		} else {
			// Fallback: reload the page to trigger normal app flow
			window.location.reload();
		}
	};
	return (
		<div
			className="flex grow flex-col w-full h-full bg-[100%_auto] bg-no-repeat
				bg-[url('@assets/images/background/background-interscreen-mobile.svg')] 
				tablet:bg-[url('@assets/images/background/background-interscreen-tablet.svg')] relative">
			<div className='flex flex-col items-center justify-center gap-8 max-w-md mx-auto text-center'>
				{/* Logo */}
				<div className='w-[150px] h-full mt-16 text-white'>
					<Logo className='w-full h-full' />
				</div>

				{/* App Name */}
				<div className='flex justify-center flex-col py-6 gap-4 bg-white rounded-lg w-[327px]'>
					<h2 className='text-xl font-semibold'>Hello Merchant</h2>
					<div className='flex items-center justify-between px-8 gap-2'>
						<div className='w-12 h-12'>
							<LogoBorder className='w-12 h-12' />
						</div>
						<p className='text-base text-left'>
							On this page, we recommend adding Kris+ Cashier icon to device home screen for easy access and updates.
						</p>
					</div>
					{/* Action Buttons */}
					<div className='flex flex-col gap-4 w-full px-8'>
						{isIOS ? (
							<div className='flex w-full font-semibold text-base justify-center items-center gap-1 whitespace-nowrap'>
								<span>Tap</span>
								<Download className='inline-block w-4 h-5 text-black' />
								<span>and select "Add to Home Screen"</span>
							</div>
						) : (
							<button onClick={onInstall} className='rounded-full py-[9px] px-4 bg-cyan hover:bg-cyan-dark'>
								<span className='text-white text-base font-semibold leading-[18px]'>Add icon to home screen</span>
							</button>
						)}
						<div className='flex items-center justify-center text-base text-gray-500'>
							<span className='border-b border-blue-grey-lighter w-full'></span>
							<span className='mx-1 text-sm'>OR</span>
							<span className='border-b border-blue-grey-lighter w-full'></span>
						</div>
						<button onClick={handleProceedToSignIn} className='flex w-full font-semibold text-base text-cyan cursor-pointer justify-center'>
							<span>Proceed to sign in</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
